import { Platform } from "react-native";
import TextEditor from "./TextEditor";
import MobileTextEditor from "./MobileTextEditor";

const CustomRichTextEditor = ({
  value,
  onChange,
  isSubmitting,
  placeholder,
  activelyEditing,
  makeImagesPublic = false,
  restrictImageUpload = false,
}: {
  value: string;
  onChange: (content: string) => void;
  isSubmitting: boolean;
  placeholder: string;
  activelyEditing: boolean;
  makeImagesPublic?: boolean;
  restrictImageUpload?: boolean;
}) => {
  const isWeb = Platform.OS === "web";

  return isWeb ? (
    <TextEditor
      value={value}
      onChange={(content) => {
        onChange(content);
      }}
      disabled={isSubmitting}
      placeholder={placeholder}
      makeImagesPublic={makeImagesPublic}
      restrictImageUpload={restrictImageUpload}
    />
  ) : (
    <MobileTextEditor
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      activelyEditing={activelyEditing}
      makeImagesPublic={makeImagesPublic}
      restrictImageUpload={restrictImageUpload}
    />
  );
};

export default CustomRichTextEditor;
